module.exports = __webpack_public_path__ + "img/12_30.8cf6f9ba.png";